import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import { loginStreet } from "../api/apps";
import { useAuth } from "../contexts/AuthContext";

export const useSaveStreetConfig = ({ onSaved } = {}) => {
  const { setApiUser } = useAuth();
  const [error, setError] = useState("");

  const { mutate: saveStreetConfig, isLoading: isSaving } = useMutation({
    mutationFn: (body) => loginStreet(body),
    onSuccess: (res) => {
      setError("");
      setApiUser(res.data.data);
      toast("Successfully connected", { type: "success" });
      onSaved?.();
    },
    onError: (e) => {
      setError(
        e.response?.data?.message ||
          "Could not connect to Street. Please try again.",
      );
    },
  });

  return {
    saveStreetConfig,
    isSaving,
    error,
    clearError: () => setError(""),
  };
};
